import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { type Session } from '../modal/session';

export const getSessionByIdAPI = async (sessionId: string) => {
  const response = await baseAPI.get<Session>(`/session/${sessionId}`);
  return response.data;
};

export const getSessionByIdOptions = (sessionId: string) => {
  return queryOptions({
    queryKey: [KEYS.SESSIONS, sessionId],
    queryFn: () => getSessionByIdAPI(sessionId),
    experimental_prefetchInRender: true,
    placeholderData: keepPreviousData,
  });
};

export const useGetSessionById = (
  sessionId: string,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    ...getSessionByIdOptions(sessionId),
    enabled: options?.enabled !== false && !!sessionId,
  });
};
